import React, { useState } from 'react';
import {
    makeStyles,
    Theme,
    useTheme,
} from '@material-ui/core';
import { TextField } from '../../../components/TextField';
import { FormGroup } from '../../../components/FormGroup';

export type MemberContactData = {
    contactAddress: string,
    contactId: string,
    contactPhone: string,
    contactEmail: string,
};

type MemberContactFormProps = {
    data: MemberContactData,
    onChange: (data: MemberContactData) => void,
};

MemberContactForm.defaultProps = {

};

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
    },
    title: {
        color: theme.palette.mainColor,
    },
}));

function MemberContactForm(props: MemberContactFormProps): React.ReactElement {
    const {
        data,
        onChange,
    } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [edit, setEdit] = useState(false);

    return (
        <FormGroup title="聯絡資料" actionText="修改聯絡資料" actionClick={() => setEdit(true)}>
            <TextField
                label="取件地點"
                value={data.contactAddress}
                disabled={!edit}
                onChange={(e) => onChange({
                    ...data,
                    contactAddress: e.target.value,
                })}
            />
            <TextField
                label="姓名"
                value={data.contactId}
                disabled={!edit}
                onChange={(e) => onChange({
                    ...data,
                    contactId: e.target.value,
                })}
                required
            />
            <TextField
                label="電話/手機"
                value={data.contactPhone}
                disabled={!edit}
                onChange={(e) => onChange({
                    ...data,
                    contactPhone: e.target.value,
                })}
                required
            />
            <TextField
                label="E-mail"
                value={data.contactEmail}
                disabled={!edit}
                onChange={(e) => onChange({
                    ...data,
                    contactEmail: e.target.value,
                })}
                required
            />
        </FormGroup>
    );
}

export { MemberContactForm };
